import axios from 'axios';

export const setupAxiosInterceptors = (setIsLoading) => {
  axios.interceptors.request.use(
    (config) => {
      if (!config.skipLoader) {
        setIsLoading(true);
      }
      return config;
    },
    (error) => {
      setIsLoading(false); 
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      if (!response.config.skipLoader) {
        setIsLoading(false);
      }
      return response;
    },
    (error) => {
      if (!error.config?.skipLoader) {
        setIsLoading(false);
      }
      return Promise.reject(error);
    }
  );
};
